
import $ from "jquery"
import { useCookie } from "../../support/general";
import { modelStore } from "../storage/model";
import { Button } from "react-bootstrap";

export function Security ({style}){

    var [getValue,setValue] = useCookie("password","");

    function onChange(e){
      setValue(e.target.value);
    }

    function onClick(){
        modelStore.dispatch(state=>{
          state.password = getValue();
        })
    }

    var endStyle = $.extend(true,{
        width : '100%',
        height : '100%',
        backgroundColor : 'white',
        position : 'fixed'
    },style)

    return (<div
      style = {endStyle}
    >
        <div
          style = {{
            position : 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <input autoFocus  type="password" value={getValue()} onChange={onChange} /><br/><br/>
          <Button onClick = {onClick}>Connect</Button>
        </div>
    </div>)
}

